import { OOG, OOGPosition, OrderResponseDto, UnitListDto } from '@planning/app/api'

export const mapToUnitListDto = (
  toBeMapped: OrderResponseDto,
  companyNameMap: Record<number, string>,
): UnitListDto => {
  const oog: OOG[] = []
  if (toBeMapped.overHeight) {
    oog.push({ direction: OOGPosition.Top, measurement: toBeMapped.overHeight })
  }

  if (toBeMapped.overLengthFront) {
    oog.push({ direction: OOGPosition.Front, measurement: toBeMapped.overLengthFront })
  }

  if (toBeMapped.overLengthRear) {
    oog.push({ direction: OOGPosition.Rear, measurement: toBeMapped.overLengthRear })
  }

  if (toBeMapped.overWidthLeft) {
    oog.push({ direction: OOGPosition.Left, measurement: toBeMapped.overWidthLeft })
  }

  if (toBeMapped.overWidthRight) {
    oog.push({ direction: OOGPosition.Right, measurement: toBeMapped.overWidthRight })
  }

  return {
    id: toBeMapped.id,
    containerNumber: toBeMapped.containerNumber ?? '',
    isoCode: toBeMapped.containerIsoCode,
    referenceNumber: toBeMapped.referenceNumber,
    imoClasses: toBeMapped.imoClasses,
    grossWeight: toBeMapped.grossWeight,
    isEmpty: toBeMapped.isEmpty,
    linkedOrderId: toBeMapped.linkedOrderId,
    operator: toBeMapped.operator,
    portOfDischarge: toBeMapped.portOfDischarge,
    portOfLoading: toBeMapped.portOfLoading,
    temperature: toBeMapped.temperature,
    railTrackId: toBeMapped.railTrackId,
    waggon: toBeMapped.waggon,
    vgm: toBeMapped.vgm,
    unitType: toBeMapped.unitType,
    outOfGauge: oog,
    stowagePosition: toBeMapped.stowagePosition,
    consignee: toBeMapped.consignee,
    otherLabels: toBeMapped.otherLabels,
    notes: toBeMapped.notes,
    content: toBeMapped.content,
    atConsignee: toBeMapped.atConsignee,
    doorDirection: toBeMapped.doorDirection,
    finalDestination: toBeMapped.finalDestination,
    hasSeals: toBeMapped.hasSeals,
    seals: toBeMapped.seals,
    operationalInstructions: toBeMapped.operationalInstructions,
    sequence: toBeMapped.railcarSequenceNumber,
    shipper: companyNameMap[toBeMapped.shipperId ?? -1],
    forwarder: companyNameMap[toBeMapped.forwarderId ?? -1],
    billOfLading: toBeMapped.billOfLading,
    releaseReference: toBeMapped.releaseReference,
    shippingOrderReference: toBeMapped.shippingOrderReference,
    inlandDestination: toBeMapped.inlandDestination,
    isApproved: toBeMapped.isApproved,
    placeOfOrigin: toBeMapped.placeOfOrigin,
  }
}
